import React from "react";
import Dimension from "../../models/Dimension";
import Analytics from "../../components/analytics/Analytics";

const EditDimensionAnalytics: React.FC<{data: Dimension}> = (props) => {
    return (
        <Analytics dimId={props.data.id}/>
    );
};

export default EditDimensionAnalytics;
